// extracted by mini-css-extract-plugin
export default {"cardListSkeleton":"cardListSkeleton_cardListSkeleton__K9LeR","skeleton":"cardListSkeleton_skeleton__YWfLc","skeleton-animation":"cardListSkeleton_skeleton-animation__sZuB7"};